import React, { useEffect, useState } from 'react';
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import { Box, Drawer, FormControl, FormGroup, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Link } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import DataService from '../../Service';
import { useSelector } from 'react-redux';


const drawerWidth = 480;

const useStyles = makeStyles(theme => ({
    root: {
        padding: '2rem',
        marginTop: '4rem',
        width: '25rem',
        backgroundColor: "#F5F6FA"
    },
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
    icon: {
        cursor: "pointer",
        width: "22px !important",
        height: "22px !important"
    },
    headerTitle: {
        color: '#077f83',
        fontSize: '16px',
        fontWeight: 700
    },
    title: {
        color: "#4A4A4A",
        fontSize: '13px'
    }, appBar: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginRight: drawerWidth,
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    toolbar: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
    },

}));


const StatisticsSummaryDrawer = (props) => {
    const classes = useStyles();
    const { parentCall } = props;
    const { flag } = props
    const [drawerFlag, setDrawerFlag] = useState({ drawerFlag: false });

    const globaluserData = useSelector(state=>state.commonReducer);
    const themeColor = globaluserData?.role === "admin" ? '#EF7000' : '#EF7000';
    // const themeColor = sessionStorage.getItem('role') == 'admin' ? '#EF7000' : '#EF7000';
    const [statistics, setStatistics] = useState({});
    const [viewMoreValue, setViewMoreValue] = useState(false);

    const statusArray = [
        { status: "Shortlist", assigment: "37" },
        { status: "Chemistry", assigment: "81" },
        { status: "Contracting session", assigment: "88" },
        { status: "Line manager call", assigment: "12" },
        { status: "Session 1", assigment: "27" },
        { status: "Session 2", assigment: "18" },
        { status: "Session 3", assigment: "37" },
        { status: "Session 4", assigment: "36" },
        { status: "Session 5", assigment: "15" },
        { status: "Session 6", assigment: "20" },
    ];

    useEffect(() => {
        DataService.getDirectData("/assignments/statistics", { type: "admin", organisation_id: props.organisationId })
            .then((res) => {

                // DataService.getData(params, 'list_all_assignments').then((res) => {
                if (res?.success) {
                    statistics.length = 0;
                    setStatistics(res.statistics)

                }
            })
            .catch(() => { });
    }, [props.action]);

    useEffect(() => {
        if (statistics?.statistics?.length) {
            const statisticsValue = statistics?.statistics.slice(0, 6).find(item => item.label === props.filterStatisticsValue);
            if (props.filterStatisticsValue && !statisticsValue)
                setViewMoreValue(true)
            else
                setViewMoreValue(false);
        }
    }, [props.filterStatisticsValue])





    const toggleDrawer = (anchor, open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerFlag(open);
        !open && parentCall(false)
        if (flag) {
            setDrawerFlag(open)
            open && parentCall(true)
        }
    };

    const list = (anchor) => (
        <Box className={classes.root}>
            <Grid container xs={12} direction="row" justify='space-between' >
                <Typography variant="h3" className={classes.headerTitle}>Session status summary</Typography>
            </Grid>


            <Box py={2}>
                <Grid style={{ backgroundColor: '#FFF', padding: 16 }} container xs={12} direction="row" justify='space-between'>
                    <Grid item xs={6}>
                        <Typography variant="subtitle2" gutterBottom className={classes.title}>
                            <Box fontWeight="bold">Current Status</Box>
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle2" gutterBottom className={classes.title}>
                            <Box fontWeight="bold">Number of Assignments</Box>
                        </Typography>
                    </Grid>
                </Grid>
            </Box>

            <Box>
                {statistics.length > 0 && statistics.map((data) => {
                    return (

                        <Box component="button" onClick={() => {
                            props?.fetchAssignmentsByStatistics(data?.label);
                            props?.setFilterStatisticsValue(data.label);
                            // parentCall(false)
                        }} style={{ border: 0, boxShadow: 0, backgroundColor: "#fff", width: "100%", textAlign: "left" }}>

                            <Grid container xs={12} direction="row" alignItems="center" justify='space-between'
                                style={{ borderBottom: '1px #ddd solid', padding: "10px 16px", cursor: 'pointer' }}>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle2" gutterBottom className={classes.title} style={{ color: data.label === props?.filterStatisticsValue ? themeColor : '' }}>
                                        {data?.label || "-"}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="subtitle2" gutterBottom className={classes.title} style={{ textAlign: 'center', color: data.label === props?.filterStatisticsValue ? themeColor : '' }}>
                                        {data?.value}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Box className={classes.icon} style={{ marginRight: '40px', color: data.label === props?.filterStatisticsValue ? themeColor : '' }} onClick={() => { console.log("dd", data); }}>
                                        <ArrowForwardIcon />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    );
                })}
            </Box>
        </Box >
    );
    return (
        <>
            <div>
                <React.Fragment>
                    <Drawer
                        anchor={'right'}
                        variant="permanent"
                        // open={flag}
                        className={classes.drawer}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                    >
                        {list('right')}
                    </Drawer>

                </React.Fragment>
            </div>
        </>
    );
}

export default StatisticsSummaryDrawer;